module.exports = __webpack_public_path__ + "img/levelup-logout.36af80cc.svg";